@if (manualAreasMode()) {
    <div class="manual-areas">
        <h1 class="h4 condensed">Gemarkeerde gebieden</h1>
        @if (areas()?.length === 0) {
            <div>
                Gemarkeerde gebieden zijn gebieden op de kaart die extra aandacht vragen.
                Je kunt de gebieden een eigen kleur geven, en kiezen om een melding te tonen als een punt binnen dat gebied
                aangemaakt wordt.
                <br><br>
                Plaats het midden van de kaart op het punt waar je het gebied wilt starten, en klik dan op "Nieuw gebied
                markeren".
            </div>
        }
        <div class="areas" id="area-list">
            @for (area of areas(); track area; let i = $index) {
                <div class="area">
                    <div class="area-controls">
                        <h1 class="h5 condensed">
                            @if (!area.isStreet) {
                                <i [style.color]="area.fillColor" class="fas fa-draw-polygon"></i>
                            } @else {
                                <i [style.color]="area.fillColor" class="fas fa-road"></i>
                            }
                            {{area.name}}
                        </h1>
                        @if (area.drawing) {
                            <div (click)="removeArea(area)" class="fab small me-1"><i class="fas fa-trash"></i></div>
                            <div (click)="finishArea(area)" class="fab small active"><i class="fas fa-check"></i></div>
                        }
                        @if (!area.drawing && !area.isGeoJson) {
                            <div (click)="editArea(area)" class="fab small"><i class="fas fa-pen"></i></div>
                        }
                        @if (area.isGeoJson) {
                            <div class="fab small disabled"><i class="fa-solid fa-code"></i></div>
                        }
                    </div>
                    <div [class.visible]="area.drawing" class="details">
                        @for (color of areaColors; track color) {
                            <div
                                (click)="changeColor(area, color)"
                                [class.active]="color.color == area.fillColor"
                                [style.background-color]="color.color"
                                class="color">
                            </div>
                        }
                        <div class="row">
                            <mat-form-field appearance="fill" class="col-12">
                                <mat-label>Naam</mat-label>
                                <input [(ngModel)]="area.name" matInput name="name" placeholder="Naam van het gebied" type="text">
                            </mat-form-field>
                        </div>
                        @if (area.isStreet) {
                            <div class="d-flex">
                                <div>20m</div>
                                <div class="spacer">
                                    <mat-slider
                                        [discrete]="true"
                                        [max]="150"
                                        [min]="20"
                                        [showTickMarks]="false"
                                        [step]="10"
                                        (change)="streetWithChange()"
                                        style="width: 90%;">
                                        <input [(ngModel)]="area.width" matSliderThumb/>
                                    </mat-slider>
                                </div>
                                <div>
                                    150m
                                </div>
                            </div>
                        }
                        <mat-checkbox [(ngModel)]="area.show_notification" name="show_notification">
                            Waarschuwing tonen
                        </mat-checkbox>
                        <mat-checkbox (change)="commonArea($event, area)" [checked]="!area.inspection_id" [disabled]="!inspection" name="all_inspections">
                            Toon in alle schouwronden
                        </mat-checkbox>
                        @if (isCordova) {
                            <div>
                                <b>Punten</b><br>
                                <div class="points">
                                    @for (point of area.exteriorRing; track point; let pi = $index) {
                                        <div class="point">
                                            P{{pi + 1}} <i (click)="removePoint(area, pi)" class="fas fa-times"></i>
                                        </div>
                                    }
                                    <div class="clearfix"></div>
                                </div>
                            </div>
                        }
                        <div>
                            <br>
                            <i>
                                @if (!isCordova && isStreet) {
                                    Markeer de straat door met de rechtermuisknop punten toe te voegen op de kaart.<br>
                                    Door dubbel te klikken op een punt kan deze verwijderd worden.
                                } @else if (!isCordova && !isStreet) {
                                    Teken het gebied door met de rechtermuisknop punten toe te voegen op de kaart.
                                        De punten kunnen achteraf met de muis worden versleept. <br>
                                    Door dubbel te klikken op een punt kan deze verwijderd worden.
                                } @else {
                                    Teken het gebied door de kaart naar een nieuw punt te slepen, en dan op het vinkje
                                        rechtsonderin te klikken.
                                }
                                <br><br>
                                Als je "Waarschuwing tonen" inschakelt, krijgt de gebruiker een waarschuwing bij het aanmaken
                                van een punt binnen dit gebied.</i>
                        </div>
                        <br>
                    </div>
                </div>
            }
        </div>
        <div class="actions">
            <div class="pt-2 d-flex">
                <button
                    (click)="addArea(true)"
                    [disabled]="manualAreaDrawing()"
                    class="mb-1 w-100 me-1"
                    mat-raised-button>
                    <i class="fas fa-road fa-4x"></i>
                    <br>
                    <div class="icon-button-text">
                        Nieuwe straat <br> markeren
                    </div>
                </button>
                <button
                    (click)="addArea()"
                    [disabled]="manualAreaDrawing()"
                    class="mb-1 ms-1 w-100"
                    mat-raised-button>
                    <i class="fas fa-draw-polygon fa-4x"></i>
                    <br>
                    <div class="icon-button-text">
                        Nieuw gebied <br> markeren
                    </div>
                </button>
            </div>
        </div>
    </div>
}
